import React, { FC } from "react";
import { Easing, motion } from "motion/react";

interface FadeInOut {
  active?: boolean;
  duration?: number;
  ease?: Easing;
  children: React.ReactNode;
}

const FadeInOut: FC<FadeInOut> = ({
  children,
  active = false,
  duration = 0.5,
  ease = "easeInOut",
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={active ? { opacity: [0, 1] } : { opacity: 0 }}
      transition={{ duration, ease }}
    >
      {children}
    </motion.div>
  );
};

export default FadeInOut;
